export default __webpack_public_path__ + "static/media/plus.85fae177.svg";